export default __webpack_public_path__ + "static/media/ETH.26bb1818.svg";